import { Controller } from "@hotwired/stimulus"

// FD-297 (parity): collapse a long description to a few lines with a "Show all" toggle,
// matching Plane. Read-only affordance — clicking the text still opens the full editor
// (inline-edit), which is never clamped. Applies an inline max-height so it degrades to
// the full text without JS.
//
// FD-1335: measuring once on connect is not enough.
// - The content sits in a <cs-resize-observer> whose cs-resize calls update(). Inside
//   <cs-page> the description has no layout until the page's first render, which lands
//   after Stimulus connects us, so the first real measurement comes from that event. It
//   also re-measures when the editor closes and when the width changes.
// - A morph refresh updates this element in place without reconnecting us, and it strips
//   the inline clamp and puts `hidden` back on the toggle. An expanded description does
//   not change size when that happens, so no cs-resize comes; we measure again on
//   turbo:morph, keeping whether the reader had expanded it.
export default class extends Controller {
  static targets = ["content", "toggle"]
  static values = { max: { type: Number, default: 168 } }

  connect() {
    this.expanded = false
    this.update()
    this.onMorph = () => this.update()
    document.addEventListener("turbo:morph", this.onMorph)
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.onMorph)
  }

  update() {
    const c = this.contentTarget
    c.style.maxHeight = this.expanded ? "" : `${this.maxValue}px`
    c.style.overflow = this.expanded ? "" : "hidden"
    if (!this.hasToggleTarget) return
    const overflows = c.scrollHeight > this.maxValue + 8
    this.toggleTarget.hidden = !(overflows || this.expanded)
    this.toggleTarget.textContent = this.expanded ? "Show less" : "Show all"
  }

  toggle() {
    this.expanded = !this.expanded
    this.update()
  }
}
